import React, { useState, useEffect } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { Button } from './ui/button';

// This component now only handles the Update Banner
// The App Install Button is now in the Navbar
const AppDownloadButton = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [showUpdateBanner, setShowUpdateBanner] = useState(false);

  useEffect(() => {
    // Listen for service worker updates
    const handleServiceWorkerUpdate = (event) => {
      if (event.data && event.data.type === 'SW_UPDATED') {
        console.log('App update available:', event.data.version);
        setUpdateAvailable(true);
        setShowUpdateBanner(true);
      }
    };

    // Register service worker message listener
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', handleServiceWorkerUpdate);
      
      // Check for waiting service worker
      navigator.serviceWorker.ready.then((registration) => {
        if (registration.waiting) {
          setUpdateAvailable(true);
          setShowUpdateBanner(true);
        }
        
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                setUpdateAvailable(true);
                setShowUpdateBanner(true);
              }
            });
          }
        });
      });
    }

    return () => {
      navigator.serviceWorker?.removeEventListener('message', handleServiceWorkerUpdate);
    };
  }, []);

  const handleUpdate = async () => {
    setIsUpdating(true);
    
    try {
      if (navigator.serviceWorker) {
        const registration = await navigator.serviceWorker.ready;
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      }
      
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }
      
      await new Promise(resolve => setTimeout(resolve, 1000));
      window.location.reload(true);
    } catch (error) {
      console.error('Update failed:', error);
      window.location.reload(true);
    }
  };

  if (!showUpdateBanner || !updateAvailable) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-green-600 text-white py-3 px-4 flex items-center justify-center gap-4 shadow-lg">
      <span className="text-sm font-medium">
        🆕 Eine neue Version ist verfügbar!
      </span>
      <Button
        onClick={handleUpdate}
        disabled={isUpdating}
        size="sm"
        className="bg-white text-green-700 hover:bg-green-50 rounded-none"
      >
        {isUpdating ? (
          <>
            <RefreshCw className="h-4 w-4 mr-1 animate-spin" />
            Lädt...
          </>
        ) : (
          <>
            <RefreshCw className="h-4 w-4 mr-1" />
            Jetzt aktualisieren
          </>
        )}
      </Button>
      <button 
        onClick={() => setShowUpdateBanner(false)}
        className="text-white/80 hover:text-white"
      >
        <X className="h-5 w-5" />
      </button>
    </div>
  );
};

export default AppDownloadButton;
